/* eslint-disable no-console */
import { useMemo } from 'react';

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const isProduction = process.env.NODE_ENV === 'production';

const enabledLevels: Record<LogLevel, boolean> = {
  debug: !isProduction,
  info: true,
  warn: true,
  error: true,
};

function formatMessage(level: LogLevel, message: string): string {
  const timestamp = new Date().toISOString();
  return `[${timestamp}] [${level.toUpperCase()}] ${message}`;
}

function useLogger() {
  return useMemo(() => ({
    debug: (message: string, ...args: unknown[]) => {
      if (enabledLevels.debug) {
        console.debug(formatMessage('debug', message), ...args);
      }
    },
    info: (message: string, ...args: unknown[]) => {
      if (enabledLevels.info) {
        console.info(formatMessage('info', message), ...args);
      }
    },
    warn: (message: string, ...args: unknown[]) => {
      if (enabledLevels.warn) {
        console.warn(formatMessage('warn', message), ...args);
      }
    },
    error: (message: string, ...args: unknown[]) => {
      if (enabledLevels.error) {
        console.error(formatMessage('error', message), ...args);
      }
    },
  }), []);
}

export { useLogger };
